import { ColumnType } from 'react-final-table';

// types
import { Sort } from './types';

// components
import IconSorting from '../icons/sorting';
import IconSortingArrows from '../icons/sorting-arrows';

// styles
import './table.css';

export interface TableSorterProps {
  onChange: () => void;
  sort: Sort;
  column: ColumnType<Record<string, string | number>>;
  withoutSort: boolean;
}

export default function TableSorter({
  onChange,
  sort,
  column,
  withoutSort = true,
}: TableSorterProps): React.JSX.Element {
  const handleChange = () => {
    onChange();
  };

  const contentSortIcon =
    sort.sortProp === column.name ? <IconSorting /> : <IconSortingArrows />;

  return (
    <span className={`table-head-cell-sorter ${sort.sortDir || ''}`}>
      <button
        type="button"
        onClick={() => (!withoutSort ? handleChange() : undefined)}
        tabIndex={-1}
      >
        <span className="column-label">{column.label}</span>

        {withoutSort ? (
          ''
        ) : (
          <div className="column-label-sort-icon">{contentSortIcon}</div>
        )}
      </button>
    </span>
  );
}
